"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  kr: "vi",
  한국어: "베트남어",
  "받은 알림이 없습니다": "Không có thông báo đã nhận",
  알림: "Thông báo",
  설정: "Cài đặt",
  "모두 읽음": "Đọc tất cả",
  "읽은 알림 삭제": "Xóa thông báo đã đọc",
  "모두 삭제": "Xóa tất cả",
  "변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.": "Khôi phục tất cả các cài đặt chi tiết bạn đã thay đổi về tình trạng mặc định. Cài đặt thông báo đã khởi tạo được áp dụng khi lưu.",
  "알림 콘텐츠 설정": "Cài đặt nội dung thông báo",
  초기화: "Khởi tạo",
  저장: "Lưu",
  "받은 알림이 없습니다.": "Không có thông báo đã nhận",
  "설정이 저장되었습니다.": "Cài đặt đã được lưu.",
  "설정 저장을 실패했습니다.": "Lưu các cài đặt thất bại.",
  "x 알림 x": "",
  "알림 설정": "Cài đặt thông báo",
  "에서 받고 싶은 알림을 선택하세요.": "Hãy chọn thông báo bạn muốn nhận từ",
  "안내": "Thông báo",
  "더보기": "Xem thêm",
  "<em onclick={{handleGoLogin}}>로그인</em>하시면<br />좋아하시는 BJ와 방송의<br />새로운 소식을 알려드립니다.": "Khi bạn <em onClick={{handleGoLogin}}>đăng nhập</em>,bạn sẽ nhận được thông tin mới nhất về<br /> BJ yêu thích của bạn và phát sóng.<br />"
};